import type { CSSProperties, FC, ReactNode } from 'react'

import Link from 'next/link'
import { ArrowRight } from 'lucide-react'
import { SectionLabel } from '@/components/generals/section-label'

interface Guide {
    kind: string
    title: string
    href: string
}

interface GuideLinksProps {
    title: string
    intro: string
    guides: Guide[]
    index?: string
}

/** Further reading: three guides from the blog or the dictionary, as a typeset index. */
export const GuideLinks: FC<GuideLinksProps> = ({ title, intro, guides, index }): ReactNode => (
    <section className='tone-mist relative py-20 md:py-28' data-header='light'>
        <div className='wrap grid grid-cols-12 gap-x-6 gap-y-10'>
            <div className='col-span-12 lg:col-span-4'>
                <SectionLabel index={index}>Lær mer</SectionLabel>
                <h2 className='t-h2 mt-5 balance'>{title}</h2>
                <p className='mt-4 max-w-sm text-tone-muted'>{intro}</p>
            </div>

            <ul className='col-span-12 border-t border-tone-line lg:col-span-7 lg:col-start-6'>
                {guides.map((guide, i) => (
                    <li key={guide.href} className='border-b border-tone-line' data-reveal='rise' style={{ '--d': i } as CSSProperties}>
                        <Link href={guide.href} className='group grid grid-cols-12 items-center gap-4 py-6'>
                            <span className='t-label col-span-12 text-tone-ink sm:col-span-3'>{guide.kind}</span>
                            <span className='col-span-11 text-lg font-semibold leading-snug tracking-tight transition-transform duration-500 ease-out-quint group-hover:translate-x-1 sm:col-span-8'>
                                {guide.title}
                            </span>
                            <ArrowRight className='col-span-1 size-5 justify-self-end transition-transform duration-500 ease-out-quint group-hover:translate-x-1' aria-hidden='true' />
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    </section>
)
